export interface ITokenItem {
  index: number;
  name: string;
  description?: string;
  type?: string;
  value: any;
  displayValue?: any;
}

export interface IChangeToken {
  name: string;
  description?: string;
  type?: string;
  value: any;
  tokenIndex: number;
  rowIndex: number;
  displayValue?: any | null;
}

export enum TokenFormat {
  Variable = "variable",
  Select = "select",
  Plural = "plural",
  SelectOrdinal = "selectordinal",
  Date = "date",
  Number = "number",
  Time = "time"
}
